const expandableOpenEvent = new CustomEvent('expandableopen', {
    detail: {},
    bubbles: true,
    cancelable: true,
    composed: false
});

const expandableCloseEvent = new CustomEvent('expandableclose', {
    detail: {},
    bubbles: true,
    cancelable: true,
    composed: false
});

const expandableAfterOpenEvent = new CustomEvent('expandableafteropen', {
    detail: {},
    bubbles: true,
    cancelable: true,
    composed: false
});

const expandableAfterCloseEvent = new CustomEvent('expandableafterclose', {
    detail: {},
    bubbles: true,
    cancelable: true,
    composed: false
});

class Expandable {
    constructor($el) {
        this.el = $el;
    };

    open(delay = 300) {
        if (!this.el || !this.el.classList.contains('expandable') || !this.el.classList.contains('expandable--hide')) return;

        this.el.dispatchEvent(expandableOpenEvent);

        this.el.style.height = '0px';
                            
        window.requestAnimationFrame(() => {
            this.el.classList.remove('expandable--hide');
            this.el.style.height = `${this.el.scrollHeight}px`;

            setTimeout(() => {
                this.el.style.height = '';

                this.el.dispatchEvent(expandableAfterOpenEvent);
            }, delay);
        });
    }
    
    close(delay = 600) {
        if (!this.el || !this.el.classList.contains('expandable') || this.el.classList.contains('expandable--hide')) return;

        this.el.dispatchEvent(expandableCloseEvent);

        this.el.style.height = `${this.el.scrollHeight}px`;

        window.requestAnimationFrame(() => {
            this.el.classList.add('expandable--hide');
            this.el.style.height = '0px';

            setTimeout(() => {
                if (!this.el.classList.contains('expandable--hide')) return;

                this.el.dispatchEvent(expandableAfterCloseEvent);
            }, delay);
        });
    }

    toggleExpandable() {
        if (!this.el || !this.el.classList.contains('expandable')) return;

        if (this.el.classList.contains('expandable--hide')) {
            this.open(this.el);
        } else {
            this.close(this.el);
        }
    }
}

window.Expandable = Expandable;
